/**
 * @typedef {object} PlayerParams
 * @property {string} env
 * @property {string} activitySessionId
 * @property {string} activityItemId
 */

/**
 * Gets url search query param value.
 * @param {string} queryString.
 * @param {string} param name.
 
 * @returns {string} param value.
 */

export const getUrlQueryParamValue = (queryString, paramName) => {
  const query = new URLSearchParams(queryString);
  return query.get(paramName);
};

/**
 * Gets url search query param value under state param.
 * @param {string} queryString.
 * @param {string} param name.
 
 * @returns {string} param value.
 */

export const getStateParamValue = (queryString, paramName) => {
  const stateParam = getUrlQueryParamValue(queryString, 'state');
  return getUrlQueryParamValue(stateParam, paramName);
};

/**
 * Gets url search query param value or .
 * @param {string} queryString.
 * @param {string} param name.
 
 * @returns {string} param value.
 */

export const getAuthParamValue = (queryString, paramName) =>
  getUrlQueryParamValue(queryString, paramName) ||
  getStateParamValue(queryString, paramName);

/**
 * Parses url pathname.
 * @param {string} pathname.
 
 * @returns {PlayerParams} params.
 */

export const getParams = (pathname) => {
  const [
    env,
    activitySessionId,
    authenticated,
    activityItemId,
    templateId,
    variantId,
  ] = pathname
    .replace(/\/run\//i, '')
    .replace(/\/result\//i, '')
    .split('/');
  return {
    env,
    activitySessionId,
    authenticated,
    activityItemId,
    templateId,
    variantId,
  };
};
